module.exports = __webpack_public_path__ + "static/media/fullserversbackbread.77c92e87.png";